/** Red Power Oman bundle pricing — shared by product, cart and both COD flows. */
(function (global) {
  'use strict';

  const CATALOG = [
    { keys: ['zyvero20', 'american cialis', 'cialis', 'سياليس', 'امریکن سیالس'], tiers: [1200, 1700, 2100, 2800] },
    { keys: ['healthcare-example-product-12', 'japan tengsu', 'japan', 'جابان', 'تنغسو', 'جاپان ٹینگسو'], tiers: [1200, 1700, 2100, 2800] },
    { keys: ['healthcare-example-product-116', 'big penis', 'بيج بينس', 'بگ پینس', 'قضيب كبير'], tiers: [1200, 1700, 2100, 2800] },
    { keys: ['healthcare-example-product-3', 'super max power', 'سوبر ماكس باور', 'سپر میکس پاور'], tiers: [1200, 1700, 2100, 2800] },
    { keys: ['healthcare-example-product-1111', 'blue wizard', 'بلو ويزارد', 'بلو وزارڈ'], tiers: [1200, 1700, 2500, 3333] },
    { keys: ['kama-uae', 'kamagra jelly', 'kamagra gel', 'kamagra', 'كماجرا', 'کاماگرا'], tiers: [900, 1500, 1800, 2400] },
    { keys: ['king-size-largo-enhance-enlarge-cream-40ml', 'largo cream', 'largo', 'لارجو', 'لارگو'], tiers: [900, 1500, 1800, 2400] },
    { keys: ['maxman-men-cream', 'maxman cream', 'max man cream', 'max man', 'ماكس مان', 'میکس مین'], tiers: [900, 1500, 1800, 2400] },
    { keys: ['golden-shark', 'golden shark', 'shark spray', 'shark', 'القرش', 'گولڈن شارک'], tiers: [900, 1500, 1800, 2400] },
    { keys: ['cream-super-viga', 'cream super viga', 'super viga', 'super vega', 'فيجا', 'سپر ویگا'], tiers: [900, 1500, 1800, 2400] },
    { keys: ['themra-epimedium-honey-paste-240g', 'turkish themra honey', 'turkish epimedium', 'epimedium paste', 'turkish paste', 'العسل التركي', 'العسل العثماني', 'ترکش ایپی میڈیم'], tiers: [1000, 1500, 1800, 2400] }
  ];

  const normalize = value => String(value || '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  const asTiers = values => ({ 1: Number(values[0]), 2: Number(values[1]), 3: Number(values[2]), 4: Number(values[3]) });
  const valid = tiers => [1, 2, 3, 4].every(q => Number(tiers && tiers[q]) > 0);

  function tiersFromProperties(properties) {
    const props = properties || {};
    const tiers = {
      1: Number(props._red_power_tier_1 || props._force_bundle_price_1 || 0),
      2: Number(props._red_power_tier_2 || props._force_bundle_price_2 || 0),
      3: Number(props._red_power_tier_3 || props._force_bundle_price_3 || 0),
      4: Number(props._red_power_tier_4 || props._force_bundle_price_4 || 0)
    };
    return valid(tiers) ? tiers : null;
  }

  function getTiers(product, properties) {
    // The Oman catalog is the source of truth. Prefer stable product identity so
    // old cart line properties or translated titles cannot keep stale prices.
    const identity = normalize([product?.handle, product?.product_title, product?.title, product?.name].filter(Boolean).join(' '));
    const match = CATALOG.find(entry => entry.keys.some(key => identity.includes(normalize(key))));
    if (match) return asTiers(match.tiers);
    return tiersFromProperties(properties || product?.properties);
  }

  function getBundleTotal(product, quantity, properties) {
    const q = Math.max(1, Math.floor(Number(quantity) || 1));
    const tiers = getTiers(product, properties);
    if (!tiers) return 0;
    if (q <= 3) return tiers[q];
    return Math.round((tiers[3] / 3) * q);
  }

  function getOriginalSubtotal(product, quantity, properties) {
    const q = Math.max(1, Math.floor(Number(quantity) || 1));
    const tiers = getTiers(product, properties);
    return tiers ? tiers[1] * q : Number(product?.original_line_price || product?.price * q || 0);
  }

  function getUnitPrice(product, quantity, properties) {
    const q = Math.max(1, Math.floor(Number(quantity) || 1));
    const tiers = getTiers(product, properties);
    if (q >= 4 && tiers) return tiers[3] / 3;
    return getBundleTotal(product, q, properties) / q;
  }

  function getDiscount(product, quantity, properties) {
    return Math.max(0, getOriginalSubtotal(product, quantity, properties) - getBundleTotal(product, quantity, properties));
  }

  function getPricingGroup(product, properties) {
    const tiers = getTiers(product, properties);
    return tiers ? [tiers[1], tiers[2], tiers[3], tiers[4]].join(':') : '';
  }

  /*
   * Pool quantities only when the complete bundle schedule is identical.
   * The last line in each group receives any rounding remainder, ensuring
   * line totals always add up exactly to the displayed/submitted order total.
   */
  function priceCartItems(items) {
    const rows = (items || []).map((item, index) => ({ item, index, group: getPricingGroup(item, item.properties) }));
    const groups = new Map();

    rows.forEach(row => {
      if (!row.group) return;
      if (!groups.has(row.group)) groups.set(row.group, []);
      groups.get(row.group).push(row);
    });

    const allocations = new Array(rows.length);
    groups.forEach(groupRows => {
      const quantity = groupRows.reduce((sum, row) => sum + Math.max(1, Number(row.item.quantity) || 1), 0);
      const first = groupRows[0].item;
      const total = getBundleTotal(first, quantity, first.properties);
      let allocated = 0;

      groupRows.forEach((row, groupIndex) => {
        const lineQuantity = Math.max(1, Number(row.item.quantity) || 1);
        const lineTotal = groupIndex === groupRows.length - 1
          ? total - allocated
          : Math.round((total * lineQuantity) / quantity);
        allocated += lineTotal;
        allocations[row.index] = { group: row.group, groupQuantity: quantity, groupTotal: total, lineTotal, unitPrice: total / quantity };
      });
    });

    return rows.map(row => allocations[row.index] || {
      group: '',
      groupQuantity: Number(row.item.quantity) || 1,
      groupTotal: Number(row.item.final_line_price || 0),
      lineTotal: Number(row.item.final_line_price || 0),
      unitPrice: Number(row.item.final_line_price || 0) / (Number(row.item.quantity) || 1)
    });
  }

  function formatMoney(cents, currency, locale) {
    const amount = (Number(cents) || 0) / 100;
    return (currency || 'OMR') + ' ' + new Intl.NumberFormat(locale || document.documentElement.lang || 'en', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount);
  }

  function buildAddress(area, street) {
    return [area, street].map(value => String(value || '').trim()).filter(Boolean).join(' - ');
  }

  global.RedPowerPricing = Object.freeze({ CATALOG, getTiers, getBundleTotal, getOriginalSubtotal, getUnitPrice, getDiscount, getPricingGroup, priceCartItems, formatMoney, buildAddress });
})(window);
